import React from 'react';
import { observer } from 'mobx-react';
import ShareDeviceSettingsComponent from './Share-device-settings.component';
import useShareDeviceSettings from './useShareDeviceSettings';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container = ({ onClose }: ICloseEvent) => {
    const { devices, lang, groups, app, state, handlers } =
        useShareDeviceSettings();

    return (
        <>
            <ShareDeviceSettingsComponent
                lang={lang.lang}
                demoModeError={app.demoModeError}
                serverError={devices.serverError}
                groups={groups.groupsList}
                devices={devices.deviceList}
                selectedDevices={state.selectedDevices}
                visibleList={state.visibleList}
                settingsList={devices.settingsList}
                settingDeviceImei={devices.settingDeviceImei}
                onGroupClick={handlers.handleGroupClick}
                onDeviceClick={handlers.handleDeviceClick}
                onDeviceSelect={handlers.handleDeviceSelect}
                onShareClick={handlers.handleShareClick}
                onCancel={onClose}
            />
        </>
    );
};

const ShareDeviceSettingsContainer = observer(Container);

export default ShareDeviceSettingsContainer;
